// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{\n    height: 100vh;\n    width: 100vw;\n}\n._2EwKcTdl-fmE6BDhEM0tZP{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: space-around;\n}", "",{"version":3,"sources":["webpack://src/components/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC","sourcesContent":["body{\n    height: 100vh;\n    width: 100vw;\n}\n.primary{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: space-around;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "_2EwKcTdl-fmE6BDhEM0tZP"
};
export default ___CSS_LOADER_EXPORT___;
